import axios from 'axios';

const searchInput = document.getElementById('seachInput');
const results = document.getElementById('searchResults');

if (searchInput) {

    searchInput.addEventListener('keydown', searchD);
    searchInput.addEventListener('keyup', searchD);
    searchInput.addEventListener('click', searchD);
}

var currentPrompt = '';
var items = 0;

document.addEventListener('scroll', function() {
    results.classList.remove('header-main__search-results--active');
})

function searchD() {
    const value = searchInput.value;

    if (value.length <= 0) {
        currentPrompt = '';
        results.classList.remove('header-main__search-results--active');
    }

    // const promptFirstLetters = currentPrompt.slice(0, value.length);

    if (value.length > 3) {
        if(items > 0){
            results.classList.add('header-main__search-results--active')
        }

        if (currentPrompt.includes(value) === false) {

            axios('http://laveo.atomonline.pl/includes/autocomplete.php?term=' + `"${value}"`)
                .then(({
                    data
                }) => {
                    currentPrompt = data.prompt;

                    items = (data.list) ? data.list.length : 0;

                    if (data.list) {
                        results.innerHTML = '';
                        results.classList.add('header-main__search-results--active')

                        data.list.forEach(el => {
                            results.innerHTML += `<div class="header-main__search-item"><a href=""><img src="${el.image}"><p><span>${el.label2}</span>${el.label}</p></a></div>`
                        });
                        results.innerHTML += `<div class="header-main__search-item"><button type="submit">...</button></div>`
                    } else {
                        results.classList.remove('header-main__search-results--active');
                    }
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }
}

document.addEventListener("click", (evt) => {
    let targetElement = evt.target;
    do {
        if (targetElement == results) {
            return;
        } else
            targetElement = targetElement.parentNode;

    } while (targetElement);
    if(results) {
        results.classList.remove('header-main__search-results--active');
    }
});